<vi-page
  [attr.data-at-installation-details-installationId]="installationId"
  class="page-content"
  [sidenavs]="true"
  [footer]="true"
  [desktopMarginLeft]="true"
>
  <!-- left menu sidenav -->
  <app-sidenav left-sidenav [gatewaySerial]="gatewaySerial"></app-sidenav>

  <!-- sticky panel -->
  <app-sticky-panel
    stickyPanel
    data-at-black-sidenav
    [gatewaySerial]="gatewaySerial"
  ></app-sticky-panel>

  <!-- loader -->
  <vi-loader
    body
    data-at-loader
    *ngIf="!(installationDetailsStore.hasInstallationDetailsLoaded$ | async)"
    message="{{ '+INSTALLATIONS.INSTALLATION.LOADING_MESSAGE' | translate }}"
    [isLoading]="true"
  ></vi-loader>

  <!-- head -->
  <ng-container *ngIf="gatewayStatus$ | async as gatewayStatus" head>
    <ng-container *ngIf="installationDetailsStore.hasInstallationDetailsLoaded$ | async" head>
      <ng-container *ngIf="!dragDropEditMode">
        <app-callback-notification></app-callback-notification>
        <ng-container *ngIf="statusPageStore.status$ | async as status">
          <app-banner *ngIf="status === StatusPageStatus.Major_Outage" [type]="'info'">
            {{ 'GENERAL.STATUSPAGE.ERROR_MESSAGE' | translate }}
          </app-banner>
        </ng-container>
        <app-installation-details-header></app-installation-details-header>

        <ng-container
          *ngIf="
            (installationDetailsStore.getSelectedDashboardSlug$ | async) === DashboardTypes.DEFAULT
          "
        >
          <app-installation-details-menu-bar
            *ngIf="installationDetailsStore.isMenuBarVisible$ | async"
            [firstCircuitId]="firstCircuitId$ | async"
            [installationId]="installationId"
            [gatewaySerial]="gatewaySerial"
            [device]="device"
          ></app-installation-details-menu-bar>
          <app-banner
            *ngIf="(isMainDeviceB2C$ | async) && (activeGatewayErrors$ | async)?.length > 0"
            [title]="'+INSTALLATIONS.INSTALLATION.VITOPURE_NOTIFICATION.TITLE' | translate"
          >
            {{ '+INSTALLATIONS.INSTALLATION.VITOPURE_NOTIFICATION.SUBTITLE' | translate }}
          </app-banner>
          <app-banner
            *ngIf="(lowWifiSignalStrength$ | async) && !gatewayStatus?.remoteDiagnostic"
            [link]="
              (installationDetailsStore.isPartnerShopLinkAvailable$ | async)
                ? buyRepeaterLink
                : undefined
            "
            [linkLabel]="
              (installationDetailsStore.isPartnerShopLinkAvailable$ | async)
                ? ('+INSTALLATIONS.INSTALLATION.WIFI_SIGNAL_BANNER.STORE_LINK' | translate)
                : undefined
            "
            linkGtm="onGoToShop"
            linkGtmAction="Buy repeater"
            linkGtmCategory="installationDetails"
            [linkInNewLine]="true"
          >
            {{ '+INSTALLATIONS.INSTALLATION.WIFI_SIGNAL_BANNER.DESCRIPTION' | translate }}
          </app-banner>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- body -->
  <ng-container body *ngIf="installationDetailsStore.hasInstallationDetailsLoaded$ | async">
    <ng-container *ngIf="gatewayStatus$ | async as gatewayStatus">
      <ng-container *ngIf="gatewayStatus.remoteDiagnostic === false; else noData">
        <ng-container *ngIf="!dragDropEditMode; else dragDropEdit">
          <ng-container
            *ngIf="
              (installationDetailsStore.getSelectedDashboardSlug$ | async) !== DashboardTypes.HEMS
            "
          >
            <div class="header">
              <h1>
                <ng-container *ngIf="isCascadeInstallation">
                  {{
                    '+INSTALLATIONS.INSTALLATION.CASCADES_LEAD_DEVICE_DASHBOARD.TITLE' | translate
                  }}
                </ng-container>
                <ng-container *ngIf="!isCascadeInstallation">
                  {{ '+INSTALLATION_DETAILS.DASHBOARD' | translate }}
                </ng-container>
              </h1>
              <button
                class="dashboard-edit-btn"
                mat-mini-fab
                color="accent"
                gtm="onEditBtn"
                gtmAction="Installation details tiles order"
                gtmCategory="DragDrop"
                (click)="toggleDragDropEditPanel()"
              >
                <img class="icon" icon src="/assets/icons/reorder-list.svg" />
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="installationDetailsStore.panelsOrderLoaded$ | async; else loading">
            <ng-container
              *ngIf="
                (devicesStore.isV2Cascade$ | async) && !(devicesStore.isWallboxDevice$ | async);
                else defaultInstallation
              "
            >
              <ng-container [ngSwitch]="installationDetailsStore.getSelectedDashboardSlug$ | async">
                <app-hems
                  *ngSwitchCase="DashboardTypes.HEMS"
                  [boilerSerial]="boilerSerial"
                ></app-hems>

                <!-- Solarlog -->
                <app-solarlog *ngSwitchCase="DashboardTypes.SOLARLOG"></app-solarlog>

                <!-- Pv Immersion Heater -->
                <app-pv-heater *ngSwitchCase="DashboardTypes.PV_IMMERSION_HEATER"></app-pv-heater>

                <!-- Dry contact Heat pump -->
                <app-dry-contact-feature-tiles
                  *ngSwitchCase="DashboardTypes.DRY_CONTACT"
                ></app-dry-contact-feature-tiles>

                <!-- Dry contact generic -->
                <app-dry-contact-generic-feature-tile
                  *ngSwitchCase="DashboardTypes.DRY_CONTACT_GENERIC_CONSUMER"
                ></app-dry-contact-generic-feature-tile>

                <app-v2-cascade-feature-tiles
                  *ngSwitchDefault
                  [gatewaySerial]="gatewaySerial"
                  [installationId]="installationId"
                  [isLegacyDevice]="isLegacyDevice"
                >
                </app-v2-cascade-feature-tiles>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #loading>
            <vi-loader data-at-loader [isLoading]="true"></vi-loader>
          </ng-template>

          <ng-template #defaultInstallation>
            <ng-container [ngSwitch]="installationDetailsStore.getSelectedDashboardSlug$ | async">
              <!-- NBIOT -->
              <app-nbiot *ngSwitchCase="DashboardTypes.NBIOT"></app-nbiot>

              <!-- Solarlog -->
              <app-solarlog *ngSwitchCase="DashboardTypes.SOLARLOG"></app-solarlog>

              <!-- Pv Immersion Heater -->
              <app-pv-heater *ngSwitchCase="DashboardTypes.PV_IMMERSION_HEATER"></app-pv-heater>

              <!-- Dry contact Heat pump -->
              <app-dry-contact-feature-tiles
                *ngSwitchCase="DashboardTypes.DRY_CONTACT"
              ></app-dry-contact-feature-tiles>

              <!-- Dry contact generic -->
              <app-dry-contact-generic-feature-tile
                *ngSwitchCase="DashboardTypes.DRY_CONTACT_GENERIC_CONSUMER"
              ></app-dry-contact-generic-feature-tile>

              <!-- Wallbox -->
              <app-wallbox-feature-tiles
                *ngSwitchCase="DashboardTypes.WALLBOX"
              ></app-wallbox-feature-tiles>

              <!-- HEMS -->
              <app-hems
                *ngSwitchCase="DashboardTypes.HEMS"
                [boilerSerial]="boilerSerial"
              ></app-hems>

              <app-default-feature-tiles
                *ngSwitchDefault
                [installationId]="installationId"
                [isCascadeInstallation]="isCascadeInstallation"
                [isLegacyDevice]="isLegacyDevice"
              >
              </app-default-feature-tiles>
            </ng-container>

            <ng-container *ngIf="lagDevices$ | async as lagDevices">
              <div class="header" *ngIf="isCascadeInstallation">
                <div class="header-title">
                  {{ '+INSTALLATIONS.INSTALLATION.CASCADES_LAG_DEVICES.TITLE' | translate }}
                </div>
              </div>

              <div
                *ngIf="lagDevices.length"
                class="cascade-lag-devices-container flex flex-row flex-wrap gap-[10px] justify-start items-center"
              >
                <ng-container *ngFor="let lagDevice of lagDevices">
                  <app-lag-device-tile
                    [lagDevice]="lagDevice"
                    (showDetails)="onShowLagDeviceDetails($event)"
                  >
                  </app-lag-device-tile>
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>

        <ng-template #dragDropEdit>
          <app-drag-drop-mobile
            [orderKey]="(installationDetailsStore.getSelectedGateway$ | async)?.serial"
            (doneEditing)="toggleDragDropEditPanel()"
          ></app-drag-drop-mobile>
        </ng-template>

        <ng-container
          *ngIf="
            (installationDetailsStore.panelsOrderLoaded$ | async) &&
            (devicesStore.heatingSystemOverviewUrl$ | async) as overviewUrl
          "
        >
          <app-plant-overview-link [overviewUrl]="overviewUrl"></app-plant-overview-link>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <app-no-data data-at-diagnostics-mode icon="maintenance-mode">
          <p class="no-data__info">
            {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_MODE' | translate }}
          </p>
          <div class="flex flex-row justify-center items-center">
            <ng-container [ngSwitch]="isRemoteDiagnsticsSessionOpen">
              <button
                *ngSwitchCase="true"
                data-at-device-card-open-remote-diagnostics-page
                (click)="openDiagnosticOverlay()"
                mat-stroked-button
                color="primary"
                gtm="onGoToPage"
                gtmAction="Open remote diagnostics"
                gtmCategory="deviceCard"
                matTooltip="{{ '+DIAGNOSTIC.NAVIGATION.SESSION_RUNNING' | translate }}"
                matTooltipPosition="below"
              >
                {{ '+DIAGNOSTIC.NAVIGATION.SESSION_RUNNING' | translate }}
              </button>
              <button
                *ngSwitchCase="false"
                data-at-device-card-open-remote-diagnostics-modal
                (click)="openDiagnosticOverlay()"
                mat-stroked-button
                color="primary"
                gtm="onOpen"
                gtmAction="Remote diagnostics modal"
                gtmCategory="deviceCard"
                matTooltip="{{ '+DIAGNOSTIC.NAVIGATION.SESSION_START' | translate }}"
                matTooltipPosition="below"
              >
                {{ '+DIAGNOSTIC.NAVIGATION.SESSION_START' | translate }}
              </button>
            </ng-container>
          </div>
        </app-no-data>
      </ng-template>
    </ng-container>
  </ng-container>

  <!-- footer -->
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>

  <!-- overlays -->

  <app-remote-service-overlay
    *ngIf="
      (installationDetailsStore.hasInstallationDetailsLoaded$ | async) &&
      isRemoteServiceOverlayOpen &&
      !isRemoteDiagnsticsSessionOpen
    "
    body
    [activeOverlay]="uiService.activeRemoteServiceOverlay$ | async"
    [installationId]="installationId"
    [gatewaySerial]="gatewaySerial"
  >
  </app-remote-service-overlay>

  <app-diagnostics-overlay
    *ngIf="
      (installationDetailsStore.hasInstallationDetailsLoaded$ | async) && isDiagnosticOverlayOpen
    "
    body
    [attr.data-at-overlay-tile]="uiService.activeDiagnosticOverlay$ | async"
    [activeDiagnosticOverlay]="uiService.activeDiagnosticOverlay$ | async"
    [installationId]="installationId"
    [gatewaySerial]="gatewaySerial"
    [boilerSerial]="boilerSerial"
  ></app-diagnostics-overlay>

  <app-src-overlay
    *ngIf="
      (installationDetailsStore.hasInstallationDetailsLoaded$ | async) &&
      isSingleRoomControlOverlayOpen &&
      !isRemoteDiagnsticsSessionOpen
    "
    body
    [attr.data-at-overlay-tile]="uiService.activeSingleRoomControlOverlay$ | async"
    [activeSrcOverlay]="uiService.activeSingleRoomControlOverlay$ | async"
    [installationId]="installationId"
    [gatewaySerial]="gatewaySerial"
  ></app-src-overlay>

  <!-- partner access overlay -->
  <app-partner-access-overlay
    *ngIf="
      (installationDetailsStore.hasInstallationDetailsLoaded$ | async) &&
      isPartnerAccessSettingsOverlayOpen &&
      !isRemoteDiagnsticsSessionOpen
    "
    body
    [activePartnerAccessOverlay]="uiService.activePartnerAccessOverlay$ | async"
    [gatewaySerial]="gatewaySerial"
    [installationId]="installationId"
  ></app-partner-access-overlay>

  <app-overlay
    *ngIf="isOverlayOpen && !isRemoteDiagnsticsSessionOpen"
    body
    [attr.data-at-overlay-tile]="uiService.activeOverlay$ | async"
    [activeOverlay]="uiService.activeOverlay$ | async"
    [header]="uiService.activeOverlayHeader$ | async"
    [toolTipInfo]="toolTipInfo$ | async"
  >
    <app-energy-flow
      right-sidenav
      data-at-detailed-energy-flow-manager
      *ngIf="(uiService.activePanel$ | async) === availableSidePanels.EnergyFlow"
    >
    </app-energy-flow>

    <ng-container header *ngIf="(uiService.activeOverlay$ | async) === availableOverlays.Gateway">
      <button mat-stroked-button data-at-more-actions [matMenuTriggerFor]="moreActionsMenu">
        {{ '+INSTALLATIONS.INSTALLATION.COMMUNICATION_MODULE.ACTIONS' | translate }}
      </button>

      <mat-menu xPosition="before" [overlapTrigger]="false" #moreActionsMenu="matMenu">
        <app-gateway-menu
          [gatewaySerial]="gatewaySerial"
          [installationId]="installationId"
        ></app-gateway-menu>
      </mat-menu>
    </ng-container>
    <!-- TODO VIG-3076 commented temporarily
      After uncommenting, please replace the condition with this one
      *ngIf="
        activeOverlay === availableOverlays.System &&
        ((emergencyMode$ | async) || (defrosting$ | async | ready) || isMultiFamily)
      " -->
    <ng-container
      header
      *ngIf="
        (uiService.activeOverlay$ | async) === availableOverlays.System &&
        ((emergencyMode$ | async) || isMultiFamily)
      "
    >
      <div *ngIf="isMultiFamily">
        <app-pill title [type]="pillType.secondary">
          {{ '+INSTALLATIONS.INSTALLATION.BOILER.MULTI_FAMILY_CHIP' | translate }}
        </app-pill>
      </div>
      <div
        *ngIf="emergencyMode$ | async | ready as emergencyMode"
        class="flex flex-row xs:flex-col gap-[8px] justify-start items-center"
      >
        <app-pill
          *ngIf="emergencyMode?.properties?.active?.value"
          title
          data-at-emergency-mode-chip
          [type]="pillType.medium"
        >
          {{ '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_ACTIVE_CHIP' | translate }}
        </app-pill>
        <button
          data-at-access-list
          mat-stroked-button
          gtm="onOpen"
          gtmAction="Emergency mode"
          gtmCategory="systemDetails"
          [disabled]="emergencyMode?.properties?.active?.value"
          [viConfirm]="{
            title: '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_CONFIRM_TITLE' | translate,
            content:
              '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE_CONFIRM_CONTENT' | translate,
            cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
            confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
          }"
          (confirm)="activateEmergencyMode()"
          (cancel)="cancelEmergencyModeConfirmation()"
        >
          {{ '+INSTALLATIONS.INSTALLATION.BOILER.EMERGENCY_MODE' | translate }}
        </button>
      </div>
      <!-- TODO VIG-3076 commented temporarily -->
      <!-- <ng-container *ngIf="defrosting$ | async | ready as feature">
        <button
          *ngIf="!feature.properties?.active?.value"
          mat-stroked-button
          color="primary"
          class="start-defrosting-btn"
          data-at-start-defrosting-btn
          gtm="onOpen"
          gtmAction="Defrosting"
          gtmCategory="systemDetails"
          [disabled]="
            feature.properties?.active?.value
              ? !(feature | executable: 'deactivate')
              : !(feature | executable: 'activate')
          "
          [viConfirm]="{
            title: '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING_DIALOG.TITLE' | translate,
            content:
              '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING_DIALOG.MESSAGE' | translate,
            cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
            confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
          }"
          (confirm)="onDefrostingProcessChange(true)"
          (cancel)="cancelDefrostingConfirmation()"
        >
          <vi-icon icon name="defrosting" size="24"></vi-icon>
          <span>{{
            '+INSTALLATIONS.INSTALLATION.HEATPUMP.START_DEFROSTING.BUTTON' | translate
          }}</span>
        </button>
        <button
          *ngIf="feature.properties?.active?.value"
          class="flex flex-row justify-start items-center"
          mat-stroked-button
          color="primary"
          class="stop-defrosting-btn"
          data-at-stop-defrosting-btn
          gtm="onOpen"
          gtmAction="Defrosting"
          gtmCategory="systemDetails"
          [disabled]="
            feature.properties?.active?.value
              ? !(feature | executable: 'deactivate')
              : !(feature | executable: 'activate')
          "
          [viConfirm]="{
            title: '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING_DIALOG.TITLE' | translate,
            content:
              '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING_DIALOG.MESSAGE' | translate,
            cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
            confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
          }"
          (confirm)="onDefrostingProcessChange(false)"
          (cancel)="cancelDefrostingConfirmation()"
        >
          <mat-spinner></mat-spinner>
          <span>{{
            '+INSTALLATIONS.INSTALLATION.HEATPUMP.STOP_DEFROSTING.BUTTON' | translate
          }}</span>
        </button>
      </ng-container> -->
    </ng-container>

    <ng-container
      header
      *ngIf="(uiService.activeOverlay$ | async) === availableOverlays.HeatingCircuit"
    >
      <app-pill
        [type]="pillType.success"
        *ngIf="(heatingZoneMode$ | async | ready)?.properties?.active?.value"
      >
        {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_ZONE_MODE' | translate }}
      </app-pill>
    </ng-container>

    <ng-container
      header
      *ngIf="(uiService.activeOverlay$ | async) === availableOverlays.CircuitHeatingZone"
    >
      <app-pill
        *ngIf="circuitPumpStatus$ | async | ready as pumpStatus"
        title
        type="{{
          (pumpStatus | value2: featurePropertyKey.status) === 'on'
            ? pillType.success
            : pillType.secondary
        }}"
      >
        <ng-container
          *ngIf="(pumpStatus | value2: featurePropertyKey.status) === 'on'; else circuitPumpOff"
        >
          {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_ON_CHIP' | translate }}
        </ng-container>
        <ng-template #circuitPumpOff>
          {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_OFF_CHIP' | translate }}
        </ng-template>
      </app-pill>
      <app-pill
        [type]="pillType.success"
        *ngIf="(heatingZoneMode$ | async | ready)?.properties?.active?.value"
      >
        {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_ZONE_MODE' | translate }}
      </app-pill>
    </ng-container>

    <ng-container
      header
      *ngIf="(uiService.activeOverlay$ | async) === availableOverlays.CallForHeatHeatingZone"
    >
      <app-pill
        *ngIf="heatingPump$ | async | ready as pumpStatus"
        title
        type="{{
          (pumpStatus | value2: featurePropertyKey.status) === 'on'
            ? pillType.success
            : pillType.secondary
        }}"
      >
        <ng-container
          *ngIf="(pumpStatus | value2: featurePropertyKey.status) === 'on'; else callForHeatPumpOff"
        >
          {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_ON_CHIP' | translate }}
        </ng-container>
        <ng-template #callForHeatPumpOff>
          {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_OFF_CHIP' | translate }}
        </ng-template>
      </app-pill>
    </ng-container>

    <ng-container header *ngIf="(uiService.activeOverlay$ | async) === availableOverlays.Dhw">
      <app-pill
        [type]="pillType.success"
        *ngIf="isMultiFamily"
        data-at-multi-family-chip
        class="multi-family-chip"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BOILER.MULTI_FAMILY_CHIP' | translate }}
      </app-pill>
    </ng-container>

    <ng-container
      header
      *ngIf="
        (uiService.activeOverlay$ | async) === availableOverlays.RefrigerantCircuit &&
        selectedRefrigerantCircuitId === '0'
      "
    >
      <button
        *ngIf="
          (installationDetailsStore.isPlusOrProPackage$ | async) || (authStore.isRsaUser() | async)
        "
        data-at-refrigerant-circuit-messages-modal-btn
        mat-stroked-button
        gtm="onOpen"
        gtmCategory="refrigerantCircuitHistory"
        color="primary"
        (click)="openRefrigerantCircuitHistoryDialog()"
      >
        {{ '+INSTALLATIONS.INSTALLATION.PANEL.REFRIGEANT_CIRCUIT_MESSAGES.BUTTON' | translate }}
      </button>
    </ng-container>

    <ng-container body [ngSwitch]="uiService.activeOverlay$ | async">
      <!-- ----------------------------- -->
      <!-- FEATURE TILE DETAILS OVERLAYS -->
      <!-- ----------------------------- -->

      <!-- system details -->
      <app-system-overlay *ngSwitchCase="availableOverlays.System"></app-system-overlay>

      <!-- gateway details -->
      <app-gateway-details-overlay
        *ngSwitchCase="availableOverlays.Gateway"
        [gatewaySerial]="(installationDetailsStore.getSelectedGateway$ | async)?.serial"
        [installationId]="installationId"
      ></app-gateway-details-overlay>

      <!-- dhw details -->
      <app-warm-water-overlay *ngSwitchCase="availableOverlays.Dhw"></app-warm-water-overlay>

      <!-- remote controller details -->
      <app-remote-controller-overlay
        *ngSwitchCase="availableOverlays.RemoteController"
        [installationId]="installationId"
      ></app-remote-controller-overlay>

      <!-- fuel cell details -->
      <app-fuel-cell-overlay *ngSwitchCase="availableOverlays.FuelCell"></app-fuel-cell-overlay>

      <!-- gas consumption -->
      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.GasConsumption"
        [chartData]="gasConsumptionChartData$ | async"
      ></app-generic-consumption-chart-overlay>

      <!-- summary gas consumption -->
      <app-generic-consumption-overlay
        *ngSwitchCase="availableOverlays.SummaryGasConsumption"
        [gasConsumptionSummaryDhw]="gasConsumptionSummaryDhw$ | async | ready"
        [gasConsumptionSummaryHeating]="gasConsumptionSummaryHeating$ | async | ready"
      ></app-generic-consumption-overlay>

      <!-- summary electricity consumption -->
      <app-generic-consumption-overlay
        *ngSwitchCase="availableOverlays.SummaryElectricityConsumption"
        [powerConsumptionSummaryDhw]="powerConsumptionSummaryDhw$ | async | ready"
        [powerConsumptionSummaryHeating]="powerConsumptionSummaryHeating$ | async | ready"
      ></app-generic-consumption-overlay>

      <!-- Summary autarky -->
      <app-generic-consumption-overlay
        *ngSwitchCase="availableOverlays.Autarky"
        [autarkySummary]="autarkySummary$ | async | ready"
      ></app-generic-consumption-overlay>

      <!-- Power Production -->
      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.PowerProduction"
        [chartData]="powerProductionChartData$ | async"
      ></app-generic-consumption-chart-overlay>

      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.SolarPowerProduction"
        [chartData]="solarPowerProductionChartData$ | async"
      ></app-generic-consumption-chart-overlay>

      <!-- electricity consumption -->
      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.ElectricityConsumption"
        [chartData]="powerConsumptionChartData$ | async"
        [isElectricityConsumption]="true"
      >
      </app-generic-consumption-chart-overlay>

      <!-- fuel consumption -->
      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.FuelConsumption"
        [chartData]="powerConsumptionChartData$ | async"
        [isElectricityConsumption]="false"
      >
      </app-generic-consumption-chart-overlay>

      <!-- heat production -->
      <app-generic-consumption-chart-overlay
        *ngSwitchCase="availableOverlays.HeatProduction"
        [chartData]="heatProductionChartData$ | async"
      ></app-generic-consumption-chart-overlay>

      <!-- solar details -->
      <app-solar-overlay *ngSwitchCase="availableOverlays.Solar"></app-solar-overlay>

      <!-- heating circuits details -->
      <app-heating-circuit-details-overlay
        *ngSwitchCase="availableOverlays.HeatingCircuit"
        [circuitId]="installationService.selectedCircuitId$ | async"
      >
      </app-heating-circuit-details-overlay>

      <!-- heat on demand heating zone -->
      <app-call-for-heat-heating-zone-details-overlay
        *ngSwitchCase="availableOverlays.CallForHeatHeatingZone"
      >
      </app-call-for-heat-heating-zone-details-overlay>

      <!-- standard heating zone -->
      <app-circuit-heating-zone-details-overlay
        *ngSwitchCase="availableOverlays.CircuitHeatingZone"
        [circuitId]="installationService.selectedCircuitId$ | async"
      >
      </app-circuit-heating-zone-details-overlay>

      <!-- ventilation details -->
      <app-ventilation-overlay
        *ngSwitchCase="availableOverlays.Ventilation"
      ></app-ventilation-overlay>

      <!-- electric-heater -->
      <app-electric-heater-overlay
        *ngSwitchCase="availableOverlays.ElectricHeater"
      ></app-electric-heater-overlay>

      <!-- refrigerant circuit details -->
      <app-refrigerant-circuit-details-overlay
        *ngSwitchCase="availableOverlays.RefrigerantCircuit"
        [refrigerantCircuitId]="installationService.selectedRefrigerantCircuitId$ | async"
      >
      </app-refrigerant-circuit-details-overlay>
      <app-battery-overlay *ngSwitchCase="availableOverlays.Battery"></app-battery-overlay>
      <app-photovoltaics-overlay
        *ngSwitchCase="availableOverlays.Photovoltaics"
      ></app-photovoltaics-overlay>

      <!-- wallbox charging settings  -->
      <app-wallbox-charging-mode-overlay
        *ngSwitchCase="availableOverlays.WallboxChargingSettings"
      ></app-wallbox-charging-mode-overlay>
      <!-- wallbox system overlay -->
      <app-wallbox-system-overlay
        *ngSwitchCase="availableOverlays.WallboxSystem"
      ></app-wallbox-system-overlay>

      <!-- ViCare plans overlay -->
      <app-vicare-plans-overlay
        *ngSwitchCase="availableOverlays.ViCarePlans"
      ></app-vicare-plans-overlay>

      <!-- Solar log overlay -->
      <app-solarlog-overlay *ngSwitchCase="availableOverlays.SolarLog"></app-solarlog-overlay>

      <!-- Pv Immersion Heater Details Overlay -->
      <app-pv-heater-overlay
        *ngSwitchCase="availableOverlays.PvImmersionHeaterDetails"
      ></app-pv-heater-overlay>

      <!-- ViCare thermostat overlay -->
      <app-vicare-thermostat-overlay
        *ngSwitchCase="availableOverlays.ViCareThermostat"
      ></app-vicare-thermostat-overlay>

      <!-- Internal Hydraulic details -->
      <app-internal-hydraulic-details-overlay
        *ngSwitchCase="availableOverlays.InternalHydraulic"
      ></app-internal-hydraulic-details-overlay>

      <!-- Buffer Tank details -->
      <app-buffer-tank-overlay
        *ngSwitchCase="availableOverlays.BufferTank"
      ></app-buffer-tank-overlay>

      <!-- Hybrid pro control -->
      <app-hybrid-pro-overlay
        *ngSwitchCase="availableOverlays.HybridProControl"
      ></app-hybrid-pro-overlay>

      <!-- Dry contact heat pump -->
      <app-dry-contact-heat-pump-overlay
        *ngSwitchCase="availableOverlays.DryContact"
      ></app-dry-contact-heat-pump-overlay>

      <!-- Dry contact generic consumer-->
      <app-dry-contact-generic-feature-overlay
        *ngSwitchCase="availableOverlays.DryContactGenericConsumer"
      >
      </app-dry-contact-generic-feature-overlay>

      <!-- ----------------------------- -->
      <!-- MENU BAR OVERLAYS -->
      <!-- ----------------------------- -->

      <!-- maintenance checklist -->
      <app-maintenance-checklist
        *ngSwitchCase="availableOverlays.MaintenanceChecklist"
      ></app-maintenance-checklist>

      <!-- maintenance information -->
      <app-maintenance-information-overlay
        *ngSwitchCase="availableOverlays.MaintenanceInformation"
      ></app-maintenance-information-overlay>

      <!-- power limitation history log -->
      <app-power-limitation-history-overlay
        *ngSwitchCase="availableOverlays.PowerLimitationHistoryLog"
      ></app-power-limitation-history-overlay>

      <!-- service instruction -->
      <app-service-instruction
        *ngSwitchCase="availableOverlays.ServiceInstruction"
      ></app-service-instruction>

      <!-- event log -->
      <app-event-log *ngSwitchCase="availableOverlays.EventLog"></app-event-log>

      <!-- control units -->
      <app-control-units-overlay
        *ngSwitchCase="availableOverlays.ControlUnits"
      ></app-control-units-overlay>

      <!-- trending -->
      <app-trending *ngSwitchCase="availableOverlays.Trending"></app-trending>

      <!-- cascades -->
      <app-lag-device-details-overlay
        *ngSwitchCase="availableOverlays.CascadeLagDevice"
        [lagDeviceIdx]="lagDeviceOverlayIdx"
      ></app-lag-device-details-overlay>

      <!-- eco-water details -->
      <app-eco-water-overlay *ngSwitchCase="availableOverlays.Ecowater"></app-eco-water-overlay>

      <!-- hems settings -->
      <app-hems-settings *ngSwitchCase="availableOverlays.HemsSettings"></app-hems-settings>

      <!-- service layer -->
      <app-service-layer-overlay
        *ngSwitchCase="availableOverlays.ServiceLayer"
      ></app-service-layer-overlay>
    </ng-container>
  </app-overlay>
</vi-page>
